'use client';

import { c as _c } from "react/compiler-runtime";
import arrowIcon from '@images/renders/visual_images/backArrow.svg';
import ROUTES from '@lib/constants/routes';
import { useParams, useRouter } from 'next/navigation';
import Svg from 'react-inlinesvg';
import style from './BackLink.module.scss';
function BackLink() {
  const $ = _c(11);
  const router = useRouter();
  const {
    houseId,
    bulkId,
    floorId
  } = useParams();
  const rootLink = `${ROUTES.flats.visual.root}`;
  const bulkLink = `${ROUTES.flats.visual.root}/${houseId}`;
  const floorLink = `${ROUTES.flats.visual.root}/${houseId}/${bulkId}`;
  let t0;
  if ($[0] !== bulkId || $[1] !== bulkLink || $[2] !== floorId || $[3] !== floorLink || $[4] !== houseId || $[5] !== router) {
    t0 = () => {
      if (houseId === "1") {
        router.push(floorId ? floorLink : rootLink);
        return;
      }
      if (houseId === "2") {
        if (!bulkId) {
          router.push(rootLink);
          return;
        }
        if (!floorId) {
          router.push(bulkLink);
          return;
        }
        router.push(floorLink);
      }
    };
    $[0] = bulkId;
    $[1] = bulkLink;
    $[2] = floorId;
    $[3] = floorLink;
    $[4] = houseId;
    $[5] = router;
    $[6] = t0;
  } else {
    t0 = $[6];
  }
  const switchQueue = t0;
  let t1;
  if ($[7] !== floorId || $[8] !== houseId || $[9] !== switchQueue) {
    t1 = <>{houseId ? <div className={floorId ? style.backLinkGrey : style.backLink} onClick={() => switchQueue()} role="button" tabIndex="0"><Svg src={arrowIcon.src} className={style.backIcon} /></div> : <></>}</>;
    $[7] = floorId;
    $[8] = houseId;
    $[9] = switchQueue;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}
export default BackLink;